/* eslint-disable @typescript-eslint/no-explicit-any */

export function deepFreeze<T extends string | number | symbol = string, U = any>(object: Record<T, U>) {
  // Retrieve the property names defined on object
  const propNames = Reflect.ownKeys(object);

  // Freeze properties before freezing self
  for (const name of propNames) {
    const value = (object as any)[name];

    if ((value && typeof value === "object") || typeof value === "function") {
      deepFreeze(value);
    }
  }

  return Object.freeze(object);
}
